import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Order } from 'shell/view-models/order';
import { paginationListToQueryStringForBatchAndEventManager } from 'system/utils/event-batch/list-object-to-query-string-batch-event';
import { FiltersBatchManagementVM } from 'system/view-models/batch-managment/filters-vm';

export const transformDataset = (values: FiltersBatchManagementVM): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    jobDescription: {
      value: otherValues.batchDescription || '',
    },
    jobName: {
      value: otherValues.batchName || '',
    },
  };

  const ordersToTransform = orders || {};

  const ordersMapped: Order = {
    description: ordersToTransform.batchDescription,
    name: ordersToTransform.id,
    enabled: ordersToTransform.active,
  };

  return `${paginationListToQueryStringForBatchAndEventManager({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
